import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route } from 'react-router-dom';
import { Provider } from 'mobx-react';
import { IntlProvider } from 'react-intl';
import ErrorBoundary from 'components/ErrorBoundary';
import history from 'utils/history';
import FindDesignersApp from 'apps/find-designers/components/FindDesignersApp';
import FilterStore from 'apps/find-designers/stores/FilterStore';

document.addEventListener('DOMContentLoaded', () => {
    const appNode = document.getElementById('find-designers-root');
    const appDataNode = document.getElementById('find-designers-app-data');
    const { initData } = JSON.parse(appDataNode.textContent);
    const {
        intlData,
        filters,
        urls,
        navItems,
        designers,
        pagination,
        storeFront,
        currentUser,
    } = initData;

    const filterStore = FilterStore.create({ filters });

    ReactDOM.render(
        <Provider filterStore={filterStore}>
            <IntlProvider locale={intlData.locale} messages={intlData.messages}>
                <Router history={history}>
                    <Route
                        path={'/designers/search'}
                        component={props => (
                            <ErrorBoundary>
                                <FindDesignersApp
                                    urls={urls}
                                    navItems={navItems}
                                    designers={designers}
                                    pagination={pagination}
                                    storeFront={storeFront}
                                    currentUser={currentUser}
                                    {...props}
                                />
                            </ErrorBoundary>
                        )}
                    />
                </Router>
            </IntlProvider>
        </Provider>,
        appNode
    );
});



// WEBPACK FOOTER //
// ./src/js/page/find-designers.jsx